import { Text } from '@/components/ui/text'
import { useWindowDimensions, View } from 'react-native'
import type { ReactNode } from 'react'

export type OnboardingSlideData = {
  icon: ReactNode
  title: string
  subtitle: string
}

type OnboardingSlideProps = OnboardingSlideData

export default function OnboardingSlide({ icon, title, subtitle }: OnboardingSlideProps) {
  const { width } = useWindowDimensions()

  return (
    <View className="flex-1 items-center justify-start pt-20 px-6" style={{ width }}>
      <View className="w-40 h-40 items-center justify-center">{icon}</View>
      <View className="mt-8 items-center gap-3">
        <Text className="text-[34px] font-bold text-typography-900 text-center">{title}</Text>
        <Text className="text-[17px] text-typography-500 text-center max-w-[300px]">{subtitle}</Text>
      </View>
    </View>
  )
}
